import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';

import reducers from '../../reducers';
import rootSaga from '../../saga';

function configureStore(initialState) {
  const sagaMiddleware = createSagaMiddleware();

  // eslint-disable-next-line no-underscore-dangle
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const enhancer = composeEnhancers(applyMiddleware(thunkMiddleware, sagaMiddleware));

  const store = createStore(reducers, initialState, enhancer);

  // start running root saga
  sagaMiddleware.run(rootSaga);

  return store;
}

export default () => configureStore({});



// WEBPACK FOOTER //
// ./src/App/initializers/reduxStore.js